exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.ant-btn-primary {\n  background: #F47920 !important;\n  border-color:#F47920 !important;\n}", ""]);

